import { createStore } from "vuex";
import axios from "axios";
import { Toast } from "vant";
import useShare from "../composiables/useShare.js";
import Cookies from "js-cookie";

axios.defaults.withCredentials = false;

const tip = (msg) => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true,
  });
};

export default createStore({
  state: {
    dataModal: {},
  },
  mutations: {
    initDataModal(state, dataModal) {
      console.log("dataModal", dataModal);
      state.dataModal = dataModal;
    },
    addDataModal(state, dataModal) {
      state.dataModal.list = state.dataModal.list.concat(dataModal.list);
    },
  },
  actions: {
    getCategory({ commit }) {
      let id = 0;
      let hash = window.location.hash;
      if (hash.includes("?") && hash.includes("=")) {
        id = hash.split("?")[1].split("&")[0].split("=")[1];
      }
      axios
        .get(process.env.VUE_APP_BASE_URL + "/api/category/mobileCategory", {
          params: { id: id },
        })
        .then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 0) {
              commit("updateCategory", data.data);
            } else {
              tip("网络错误，请重试");
            }
          } else {
            tip("网络错误，请重试");
          }
        })
        .catch((error) => {
          console.log(error);
          tip("网络错误，请重试");
        });
    },

    getDataModal({ commit }, { params, loading, finished, refreshing }) {
      axios
        .get(process.env.VUE_APP_BASE_URL + "/api/topic/topicArticles", {
          params: params,
        })
        .then((res) => {
          if (refreshing.value) {
            refreshing.value = false;
          }
          loading.value = false;
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 1) {
              // window.ZsrbApp.call("shareInfo", {
              //   title: data.data.title,
              //   img: data.data.shareimg,
              //   desc: data.data.summary,
              //   url: window.location.href,
              // });
              useShare(data.data);
              document.title = data.data.title;
              //友盟曝光元素
              // const { aplus_queue } = window;
              // aplus_queue.push({
              //   action: "aplus.record",
              //   arguments: [
              //     "$$_exposure",
              //     "EXP",
              //     {
              //       //key为字符串类型, value为字符串或Number类型，长度均限制在128位字符以内
              //       type: "topicNews",
              //       newsId: data.data.title,
              //       link: window.location.href,
              //       userAgent: navigator.userAgent,
              //       publishTime: data.data.publishTime,
              //     },
              //   ],
              // });
              if (params.page == 1) {
                commit("initDataModal", data.data);
              } else {
                commit("addDataModal", data.data);
              }

              if (data.data.list.length < 5) {
                finished.value = true;
              }
            } else {
              tip("网络错误，请重试");
              finished.value = true;
            }
          } else {
            tip("网络错误，请重试");
            finished.value = true;
          }
        })
        .catch((error) => {
          console.log(error);
          tip("网络错误，请重试");
        });
    },
    getViewInfoBridging({ commit }, { id }) {
      console.log(commit);
      console.log(id);
      return new Promise((resolve) => {
        axios
          .get(
            `https://zsplus-fastapi.zsnews.cn/api/plus/infos/${id}/view-info-bridging`
          )
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                resolve(data.data);
              } else {
                tip(data.msg);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    getZsplusJsBrigde() {
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/common/zsrbjsbrigeconfig")
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                resolve(data.data);
              } else {
                tip(data.msg);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    loginByZsplus({ commit }, info) {
      return new Promise((resolve) => {
        axios
          .post("https://zsrbactivity.zsnews.cn/api/common/zsplusauth", {
            sessionToken: info.sessionToken,
            head: info.head,
            nickName: info.nickName,
            phone: info.phone,
            gender: info.gender,
          })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                // 存储中山+授权用户信息
                commit("updateUser", data.data);
                sessionStorage.setItem("zsplusInfo", JSON.stringify(data.data));
                // info.nickName info.head info.sessionToken info.gender info.phone
                resolve();
              } else if (data.code == 2) {
                //sessionToken过期,需要配合iOS端做统一处理
                tip(data.msg);
              } else {
                tip(data.msg);
              }
            } else {
              tip("网络错误，请重试");
            }
          });
      });
    },
    loginByWx({ commit }, code) {
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/common/wechatoath", {
            params: {
              code,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                // 存储微信授权用户信息
                commit("updateUser", data.data);
                Cookies.set("token", data.data.token, {
                  expires: data.data.expires_in / 86400,
                });
                Cookies.set("userInfo", JSON.stringify(data.data), {
                  expires: data.data.expires_in / 86400,
                });
                resolve();
              } else {
                tip(data.msg);
              }
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
  },
  modules: {},
});
